import React from "react";
import { useLocation, useHistory } from "react-router-dom";

const NavLinkComponent = ({ to, onClick, icon, text, iconOnly = false }: any) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const isActive = to ? pathname.includes(to) : false;

  return (
    <div
      onClick={onClick ? () => onClick() : () => history.push(to)}
      title={text}
      className={`nav-link-row w-100 d-flex cursor-pointer hover-bg-gray-700 ${
        iconOnly ? "nav-link-row--icon-only" : ""
      } ${
        isActive &&
        "bg-gray-700 text-16 border-0 border-left-3 border-left-mobile-0 border-gray-100"
      }`}
    >
      <div className="nav-link-icon mx-32 my-xl-16 my-8 flex-center">
        {React.cloneElement(icon, {
          fill: isActive ? "#F7F8FC" : "#B0B2BA",
          ...icon.props,
        })}
      </div>
      <a
        className={`nav-link-text text-white-50 text-18 my-xl-16 my-8 ${
          isActive && "text-white-70"
        } ${!isActive && "text-gray-600-mobile"}`}
      >
        {text}
      </a>
    </div>
  );
};

export default NavLinkComponent;
